import { render, staticRenderFns } from "./StockTransDetails.vue?vue&type=template&id=969194be&scoped=true&"
import script from "./StockTransDetails.vue?vue&type=script&lang=js&"
export * from "./StockTransDetails.vue?vue&type=script&lang=js&"
import style0 from "./StockTransDetails.vue?vue&type=style&index=0&id=969194be&lang=scss&scoped=true&"
import style1 from "./StockTransDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969194be",
  null
  
)

export default component.exports